<template>
  <div class="grid-y space-y-12 flex-grow">
    <div class="cell flex-grow">
      <div class="grid-x space-x-2 flex-grow">
        <div class="cell auto flex flex-col">
          <b class="text-16px leading-18px mb-3">Тип объекта</b>
          <div class="flex flex-col space-y-2">
            <Check
              label="Частный"
              :value="!payload.celebrity"
              @input="() => {
                payload.celebrity = false
                payload.order = true
              }"/>
            <Check
              label="Знаменитость"
              :value="payload.celebrity"
              @input="payload.celebrity = true"/>
          </div>
        </div>
        <div class="cell auto flex flex-col">
          <template v-if="payload.celebrity">
            <b class="text-16px leading-18px mb-3">Публикация объекта</b>
            <div class="flex flex-col space-y-2">
              <Check
                label="Без ограничений"
                :value="payload.order"
                @input="payload.order = true"/>
              <Check
                label="Только просмотр и избранное"
                :value="!payload.order"
                @input="payload.order = false"/>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="cell">
      <div class="flex flex-row flex-grow items-end space-x-2">
        <button
          class="btn btn-xs btn-outline-primary flex-grow"
          @click="$emit('cancel')">Отменить</button>
        <button
          class="btn btn-xs btn-primary flex-grow"
          @click="$emit('save')">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Check from '@/components/Check.vue';

export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({
        celebrity: false,
      }),
    },
  },
  components: {
    Check,
  },
  data() {
    return {
      payload: _.cloneDeep(this.value),
    };
  },
  watch: {
    payload: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },
};
</script>
